<template>
  <div id="index">
    <div data-v-04fc903a="" class="stars">
			<div id="stars"></div>
			<div id="stars2"></div>
			<div id="stars3"></div>
		</div>
    <dv-full-screen-container class="bg">
      <dv-loading v-if="loading">Loading...</dv-loading>
      <div v-else class="host-body">
        <div class="d-flex jc-center">
          <dv-decoration-10 style="width: 33.3%; height: 0.0625rem" />
          <div class="d-flex jc-center">
            <dv-decoration-8
              :color="['#568aea', '#568aea']"
              style="width: 2.5rem; height: 0.625rem"
            />
            <div class="title">
              <span class="title-text">城市停车大数据</span>
              <!-- <dv-decoration-6
                class="title-bototm"
                :reverse="true"
                :color="['#50e3c2', '#67a1e5']"
                style="width: 3.125rem; height: 0.1rem"
              /> -->
            </div>
            <dv-decoration-8
              :reverse="true"
              :color="['#568aea', '#568aea']"
              style="width: 2.5rem; height: 0.625rem"
            />
          </div>
          <dv-decoration-10
            style="width: 33.3%; height: 0.0625rem; transform: rotateY(180deg)"
          />
        </div>

        <!-- 第二行 -->
        <div class="homeTop">
          <div class="d-flex jc-between px-2">
            <div class="d-flex d-left">
              <div class="react-right mr-3">
                <i class="iconfont icontingchechang"></i>
              </div>
              <ul>
                <li>
                  <span>车场总数</span
                  ><span>{{
                    this.$store.state.parkLaneNum.parkCount
                  }}</span>
                </li>
                <li>
                  <span>通道数</span
                  ><span>{{
                    this.$store.state.parkLaneNum.laneCount
                  }}</span>
                </li>
                <li>
                  <span>今日新增车场</span
                  ><span>{{
                    this.$store.state.parkLaneNum.parkAddCount
                  }}</span>
                </li>
              </ul>
            </div>
            <div class="d-flex d-center">
              <div class="react-center mr-3">
                <i class="iconfont iconrmb-full"></i>
              </div>
              <ul>
                <li>
                  <!-- :ref="example1" -->
                  <span>今日收费总额</span>
                  <countTo
                    class="example3"
                    :start-val="this.amount"
                    :end-val="this.amounts"
                    :duration="3000"
                    :decimals="2"
                    separator=","
                    :autoplay="true"
                  >
                  </countTo>
                  <!-- 第一段应该为0-最新金额，在第一段完成后，在啊第二段返回时，将第一段的end金额替换到start中，最新金额替换到第二段中 prefix="¥ " -->
                </li>
                <li>
                  <!-- :ref="example2" -->
                  <span>今日电子支付总额</span>
                  <countTo
                    class="example3"
                    :start-val="this.epayAmount"
                    :end-val="this.epayAmounts"
                    :duration="3000"
                    :decimals="2"
                    separator=","
                    :autoplay="true"
                  >
                  </countTo>
                </li>
              </ul>
            </div>
            <div class="d-flex d-right">
              <div class="react-left mr-3">
                <i class="iconfont iconai-phone"></i>
              </div>
              <ul>
                <li>
                  <!-- :ref="example3" prefix="¥ "-->
                  <span>今日交易总笔数</span>
                  <countTo
                    class="example3"
                    :start-val="this.count"
                    :end-val="this.counts"
                    :duration="3000"
                    :decimals="0"
                    separator=","
                    :autoplay="true"
                  >
                  </countTo>
                </li>
                <li>
                  <!-- :ref="example4" -->
                  <span>今日电子支付笔数</span>
                  <countTo
                    class="example3"
                    :start-val="this.epayCount"
                    :end-val="this.epayCounts"
                    :duration="3000"
                    :decimals="0"
                    separator=","
                    :autoplay="true"
                  >
                  </countTo>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="body-box">
          <!-- 第三行数据 -->
          <!-- <div class="content-box"> -->
          <div class="topLeft1">
            <div class="bord">
              <centerLeft1 />
            </div>
          </div>
          <div class="topLeft2">
            <div class="bord">
              <centerLeft2 />
            </div>
          </div>
          <!-- 中间 -->
          <!-- <div>
          </div> -->
          <!-- 中间 -->
          <div class="topRight1">
            <div class="bord">
              <centerRight1 />
            </div>
          </div>
          <div class="topRight2">
            <div class="bord">
              <centerRight2 />
            </div>
          </div>
          <!-- <div class="topRight3">
            <dv-border-box-8>
            </dv-border-box-8>
          </div> -->
          <!-- </div> -->
          <div class="china">
            <center />
          </div>
          <!-- 第四行数据 -->
          <div class="bototm-box">
            <div class="bottom1">
              <div class="bord">
                <bottomLeft />
              </div>
            </div>
            <div class="bottom2">
              <div class="bord">
                <bottomCenter />
              </div>
            </div>
            <div class="bottom3">
              <div class="bord">
                <bottomRight />
              </div>
            </div>
          </div>
        </div>
      </div>
    </dv-full-screen-container>
  </div>
</template>

<script>
import { formatTime } from "../utils/index.js";
import countTo from "vue-count-to";
// import { mapState } from 'vuex'
import centerLeft1 from "./centerLeft1";
import centerLeft2 from "./centerLeft2";
import centerRight1 from "./centerRight1";
import centerRight2 from "./centerRight2";
import center from "./center";
import bottomLeft from "./bottomLeft";
import bottomCenter from "./bottomCenter";
import bottomRight from "./bottomRight";
export default {
  data() {
    return {
      loading: true,
      dateDay: null,
      dateYear: null,
      dateWeek: null,
      weekday: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
      amount: 0, // 总收费金额开始
      amounts: 500, // 总收费金额结束
      epayAmount: 0, // 总电子支付金额开始
      epayAmounts: 700, // 总电子支付金额结束
      count: 0, // 总笔数开始
      counts: 800, // 总笔数结束
      epayCount: 0, // 总电子支付笔数开始
      epayCounts: 1000, // 总电子支付笔数结束
      id: 1,
    };
  },
  components: {
    centerLeft1,
    centerLeft2,
    centerRight1,
    centerRight2,
    center,
    bottomLeft,
    bottomCenter,
    bottomRight,
    countTo,
  },
  mounted() {
    this.$store.dispatch("loginStatus", true);
    this.getToken();
    this.timeFn();
    this.cancelLoading();
  },
  methods: {
    getToken() {
      let that = this;
      this.$axios
        .post(
          "cpy/data/jump?token=" + sessionStorage.getItem("datavToken"),
          null
        )
        .then((res) => {
          if (res.code == 0) {
            sessionStorage.setItem("dataVauthSign", res.data);
            that.submitGetMessageList();
          }
        })
        .catch(function (err) {
          // console.log(err);
        });
    },
    timeFn() {
      setInterval(() => {
        this.dateDay = formatTime(new Date(), "HH: mm: ss");
        this.dateYear = formatTime(new Date(), "yyyy-MM-dd");
        this.dateWeek = this.weekday[new Date().getDay()];
      }, 1000);
    },
    cancelLoading() {
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
    submitGetMessageList() {
      const that = this;
      that.$store.dispatch("getMessageList", 1); //$dispatch在vue2中已废除，此处用的是elementUI中的方法，触发actions
    },
  },
  watch: {
    // watch 可以监听 data 数据 也可以监听 全局 vuex数据
    //监听vuex中userNumber的变化
    "$store.state.reailTimeToal"(val) {
      //变化之后根据自己项目需求写自身的逻辑代码，下面只是示例
      this.amount = this.amounts;
      this.epayAmount = this.epayAmounts;
      this.count = this.counts;
      this.epayCount = this.epayCounts;
      this.amounts = val.amount;
      this.epayAmounts = val.epayAmount;
      this.counts = val.count;
      this.epayCounts = val.epayCount;
    },
  },
};
</script>

<style lang="scss">
@import "../assets/scss/index.scss";
@import "../assets/Digital/Digital.css";
@import "../utils/parkLogin.css";
</style>